// src/modules/admin/vidcents/store/invoices.js
import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    tabs: ['all', 'query'],
    activeTab: 'all',

    rowsByTab:  { all: [], paypal: [], wise: [], query: [] },
    pageByTab:  { all: 1,  paypal: 1,  wise: 1,  query: 1  },
    perPageByTab: { all: 15, paypal: 15, wise: 15, query: 15 },
    totalByTab: { all: 0,  paypal: 0,  wise: 0,  query: 0  },

    loading: false,

    lastSearch: '',
    lastStatus: '',
    lastMinAmount: 50,
    lastPaymentMethod: '',
    lastMonth: '',
  },

  getters: {
    rows: (s) => (s.rowsByTab[s.activeTab] || []),
    page: (s) => (s.pageByTab[s.activeTab] || 1),
    per_page: (s) => (s.perPageByTab[s.activeTab] || 15),
    total: (s) => (s.totalByTab[s.activeTab] || 0),
  },

  mutations: {
    setActiveTab (s, tab) { s.activeTab = tab },
    setLoading (s, v) { s.loading = !!v },

    setRows (s, payload) {
      const tab = payload.tab
      const rows = Array.isArray(payload.rows) ? payload.rows : []
      s.rowsByTab[tab] = rows
    },
    setPage (s, payload) {
      const tab = payload.tab
      const page = Number(payload.page) || 1
      s.pageByTab[tab] = page
    },
    setPerPage (s, payload) {
      const tab = payload.tab
      const perPage = Number(payload.perPage) || 15
      s.perPageByTab[tab] = perPage
    },
    setTotal (s, payload) {
      const tab = payload.tab
      const total = Number(payload.total) || 0
      s.totalByTab[tab] = total
    },

    setLastFilters (s, payload) {
      const hasSearch     = typeof payload.search     !== 'undefined' && payload.search     !== null
      const hasStatus     = typeof payload.status     !== 'undefined' && payload.status     !== null
      const hasMinAmount  = typeof payload.min_amount !== 'undefined' && payload.min_amount !== null
      const hasPayMethod  = payload.payment_method !== undefined
      const hasMonth      = typeof payload.month      !== 'undefined' && payload.month      !== null

      if (hasSearch)    s.lastSearch    = payload.search
      if (hasStatus)    s.lastStatus    = payload.status
      if (hasMinAmount) s.lastMinAmount = Number(payload.min_amount)
      if (hasPayMethod)  s.lastPaymentMethod = payload.payment_method || ''
      if (hasMonth)     s.lastMonth     = payload.month
    },
  },

  actions: {
    async read ({ state, commit }, opts) {
      opts = opts || {}
      const t = opts.tab || state.activeTab

      const pageFromOpts = (typeof opts.page !== 'undefined' && opts.page !== null) ? opts.page : null
      const currentPage = pageFromOpts !== null ? pageFromOpts : (state.pageByTab[t] || 1)
      const perPage = state.perPageByTab[t] || 15

      const searchParam = (typeof opts.search !== 'undefined' && opts.search !== null)
        ? opts.search
        : state.lastSearch
      const statusParam = (typeof opts.status !== 'undefined' && opts.status !== null)
        ? opts.status
        : state.lastStatus

      const minAmountParam = (typeof opts.min_amount !== 'undefined' && opts.min_amount !== null)
        ? Number(opts.min_amount)
        : state.lastMinAmount

      const paymentMethodParam = (typeof opts.payment_method !== 'undefined' && opts.payment_method !== null)
        ? opts.payment_method
        : state.lastPaymentMethod

      const monthParam = (typeof opts.month !== 'undefined' && opts.month !== null)
        ? opts.month
        : state.lastMonth

      commit('setLoading', true)
      try {
        const resp = await axios.admin.get('/invoices', {
          params: {
            tab: t,
            search: searchParam,
            status: statusParam,
            page: currentPage,
            min_amount: minAmountParam,
            payment_method: paymentMethodParam,
            month: monthParam,
          },
        })
        const data = resp.data || {}

        const rows = data.data || data.rows || []
        const total =
          (typeof data.total !== 'undefined' && data.total !== null) ? data.total
            : (data.meta && typeof data.meta.total !== 'undefined') ? data.meta.total
              : rows.length

        const current =
          (typeof data.current_page !== 'undefined' && data.current_page !== null) ? data.current_page
            : (data.meta && typeof data.meta.current_page !== 'undefined') ? data.meta.current_page
              : currentPage

        const per_page =
          (typeof data.per_page !== 'undefined' && data.per_page !== null) ? data.per_page
            : (data.meta && typeof data.meta.per_page !== 'undefined') ? data.meta.per_page
              : perPage

        commit('setRows',   { tab: t, rows })
        commit('setTotal',  { tab: t, total })
        commit('setPage',   { tab: t, page: current })
        commit('setPerPage',{ tab: t, perPage: per_page })

        if (typeof opts.search !== 'undefined' || typeof opts.status !== 'undefined' || typeof opts.month !== 'undefined') {
          commit('setLastFilters', {
            search: opts.search,
            status: opts.status,
            min_amount: opts.min_amount,
            payment_method: opts.payment_method,
            month: opts.month,
          })
        }
      } finally {
        commit('setLoading', false)
      }
    },

    async goToPage ({ state, commit, dispatch }, page) {
      const tab = state.activeTab
      commit('setPage', { tab, page })
      await dispatch('read', { tab, page })
    },

    async switchTab ({ commit, dispatch }, tab) {
      commit('setActiveTab', tab)
      await dispatch('read', { tab })
    },

    async notify ({ dispatch, state }, payload) {
      const ids = (payload && payload.invoice_ids) || []
      if (!Array.isArray(ids) || !ids.length) return
      await axios.admin.post('/invoices/notify', { invoice_ids: ids })
      await dispatch('read', { tab: state.activeTab })
    },
  },
}